/**
 * The span a picked column stands for, as the drill-down asks for it: a day is itself, a month is
 * its first day to its last (or to today for the month so far).
 */
import type { ReactNode } from 'react';
import { dayWord, isoWeekday, monthWord, weekdayWords } from './volume-math';

export interface Span {
  from: string;
  to: string;
  /** "Tue, Sep 29, 2026" or "September 2026, so far". */
  title: string;
}

export function daySpan(day: string, locale: string): Span {
  return {
    from: day,
    to: day,
    title: `${weekdayWords[isoWeekday(day) - 1]}, ${dayWord(day, locale, true)}`,
  };
}

/** The last day of a yyyy-MM month, or `today` when the month is the current one. */
export function monthSpan(month: string, today: string, locale: string): Span {
  const [y, m] = month.split('-').map(Number);
  const last = new Date(Date.UTC(y ?? 1970, m ?? 1, 0)).toISOString().slice(0, 10);
  const current = today.startsWith(month);
  return {
    from: `${month}-01`,
    to: current ? today : last,
    title: `${monthWord(month, locale, true)}${current ? ', so far' : ''}`,
  };
}

/** Draws the detail behind a picked span; the app fetches it, the card places it under the chart. */
export type RenderBreakdown = (span: Span, close: () => void) => ReactNode;
